import * as React from 'react';
import { FormFieldInput } from '@cian/ui-kit';

export interface IPhoneFieldViewProps {
  value: string;
  error: string;
  placeholder?: string;
  autoFocus?: boolean;
  onBlur?: () => void;
  onChange(value: string): void;
}

export const PhoneFieldView: React.FC<IPhoneFieldViewProps> = props => {
  const { value, onChange, error, placeholder, autoFocus, onBlur } = props;

  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value),
    [onChange],
  );

  return (
    <FormFieldInput
      type="text"
      invalid={Boolean(error)}
      placeholder={placeholder}
      onChange={handleChange}
      onBlur={onBlur}
      errorMessage={error}
      value={value}
      size="M"
      autoFocus={autoFocus}
      data-testid="phone-input"
    />
  );
};

PhoneFieldView.displayName = 'PhoneField';
